import isEmpty from 'lodash/isEmpty';

export const formatResponse = response => {
  const formattedData = response.data.data.map(item => ({
    ...item,
    primaryHiringAuthority:
      item?.primaryHiringAuthority && !isEmpty(item?.primaryHiringAuthority)
        ? { ...item.primaryHiringAuthority, jobOrderId: item.id }
        : null
  }));

  return { ...response, data: { ...response.data, data: formattedData } };
};
